module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.images.length > 0) ? _c('div', {
    staticClass: "thumbnail"
  }, [_c('div', {
    staticClass: "thumbnail-full"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedThumbnail
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "enlarge-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showImage(_vm.selectedThumbnail)
      }
    }
  }, [_vm._v("\n      View\n    ")])]), _vm._v(" "), (_vm.images.length > 1) ? _c('div', {
    staticClass: "thumbnail-list"
  }, _vm._l((_vm.images), function(thumbnail, i) {
    return _c('a', {
      key: i,
      staticClass: "thumbnail-list-item",
      class: {
        selected: i === _vm.selectedIndex
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectThumbnail(i)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": thumbnail
      }
    })])
  }), 0) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6511f38a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnail.vue
// module id = 1173
// module chunks = 0